import {defineStore} from 'pinia';
import {authStore} from "@/store/authStore";
import {profileStore} from "@/store/profileStore";

export const takeOverStore = defineStore('takeOverStore',{
    state: () => ({
        takeOverModalState: false
    }),
    actions: {
        initTakeOver() {
            console.log('initTakeOver');

            if (!authStore().userLoggedIn) {
                this.notAuthTakeOverProcess();
            } else {
                this.openTakeOverModal();
            }
        },
        notAuthTakeOverProcess() {
            authStore().toggleLoginModalState();

            localStorage.setItem("notAuthTakeOverProcess", JSON.stringify({
                id: profileStore().politicianProfile.user.id
            }));

            authStore().setSignUpCustomCallback(()=> {
                const profileInfo = localStorage.getItem('notAuthTakeOverProcess');
                if (profileInfo) {
                    const profileId = JSON.parse(profileInfo).id;
                    window.location.href = `/user/${profileId}`;
                }
            });
        },
        openTakeOverModal() {
            this.takeOverModalState = true;
        },
        closeTakeOverModal() {
            this.takeOverModalState = false;
            localStorage.removeItem('notAuthTakeOverProcess');
        }
    }
});